var render = function render(_c,_vm){return _c('div',{staticClass:"layout-sidebar"},[_c('nav',{staticClass:"navigation"},[_vm._t("nav")],2),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }